/* PDP gallery fit — DymoOnline
 *
 * Two separate problems with the product gallery column, both fixed here because
 * both need runtime measurement of the live DOM.
 *
 * 1. Thumbnail rail height
 *    .product__media-wrapper is display:flex; align-items:center. The theme's own JS
 *    writes an inline min-height on .product__media-sublist-outer that makes the rail
 *    TALLER than the main image, so the rail drives the flex row height and the image
 *    is centred inside it. Result: the gallery column starts ~40px below the top of
 *    the info column, the rail overhangs the image top and bottom, and the last
 *    thumbnail is sliced because the rail height is not a whole multiple of the
 *    thumbnail pitch. Fix: size the rail to the largest WHOLE number of thumbnails
 *    that fits inside the main image height.
 *
 * 2. Where the sticky gallery stops
 *    The gallery is position:sticky inside .product__main, which is stretched to the
 *    row height and ends ~60px BELOW the info column. Sticky releases at the bottom of
 *    its containing block, so the gallery kept travelling after the info column had
 *    finished and the two columns ended out of line. Fix: give the gallery a bottom
 *    margin equal to that overhang, which pulls the release point up so both columns
 *    finish level. Measured rather than hard-coded because the overhang depends on the
 *    section's padding, which varies by template and breakpoint.
 *
 * Why a stylesheet and not inline styles (for the rail)
 *    The theme rewrites the element's entire inline style attribute AFTER this script
 *    runs, which wipes anything set inline, even with !important. A rule in a
 *    stylesheet marked !important beats a later inline declaration that is not itself
 *    marked !important, so the stylesheet survives whatever the theme writes. The
 *    bottom margin in (2) is safe inline — the theme never touches that element.
 *
 * Desktop only (>=990px). Below that the rail is horizontal and the columns stack.
 */
(function () {
  "use strict";

  if (window.__pdpGalleryFit) return;
  window.__pdpGalleryFit = 1;

  var BP = 990;
  var STYLE_ID = "pdp-gallery-fit";
  var SEL = {
    wrap: ".product__media-wrapper",
    image: ".product__media-list-wrapper",
    outer: ".product__media-sublist-outer",
    list: ".product__media-sublist",
    slide: ".product__media-subitem, .swiper-slide",
    info: ".product__info-container"
  };

  var lastRule = null;

  function styleNode() {
    var el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement("style");
      el.id = STYLE_ID;
      document.head.appendChild(el);
    }
    return el;
  }

  function write(rule) {
    if (rule === lastRule) return;
    lastRule = rule;
    styleNode().textContent = rule;
  }

  /* ---- 1. rail height ---- */

  function fitRail() {
    var wrap = document.querySelector(SEL.wrap);
    if (!wrap) return;

    var image = wrap.querySelector(SEL.image);
    var list = wrap.querySelector(SEL.list);
    if (!image || !list) return;

    if (window.innerWidth < BP) {
      write("");
      return;
    }

    var slides = list.querySelectorAll(SEL.slide);
    if (slides.length < 2) return;

    var a = slides[0].getBoundingClientRect();
    var b = slides[1].getBoundingClientRect();
    var thumb = Math.round(a.height);
    var pitch = Math.round(b.top - a.top);
    if (!thumb || pitch <= thumb) return;   // horizontal rail, or not laid out yet

    var gap = pitch - thumb;
    var avail = Math.round(image.getBoundingClientRect().height);
    if (!avail) return;

    var n = Math.max(1, Math.floor((avail + gap) / pitch));
    var h = n * thumb + (n - 1) * gap;
    if (h > avail) return;                  // never let the rail exceed the image

    write(
      SEL.outer + "," + SEL.list + "{" +
      "height:" + h + "px !important;" +
      "min-height:" + h + "px !important;" +
      "max-height:" + h + "px !important;}"
    );
  }

  /* ---- 2. sticky release point ---- */

  function alignStickyEnd() {
    var wrap = document.querySelector(SEL.wrap);
    var info = document.querySelector(SEL.info);
    var main = wrap && wrap.parentElement;
    if (!wrap || !info || !main) return;

    wrap.style.removeProperty("margin-bottom");   // measure the untouched geometry

    if (window.innerWidth < BP) return;           // stacked layout: nothing to align

    var overhang = Math.round(
      main.getBoundingClientRect().bottom - info.getBoundingClientRect().bottom
    );
    if (overhang > 0) {
      wrap.style.setProperty("margin-bottom", overhang + "px", "important");
    }
  }

  function apply() {
    fitRail();
    alignStickyEnd();
  }

  function schedule() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(apply);
    });
  }

  function start() {
    schedule();

    // The theme finishes sizing the rail some time after DOMContentLoaded, and images
    // finishing load can change the main image height. Re-measure a few times early on.
    [200, 600, 1200, 2500].forEach(function (ms) { setTimeout(apply, ms); });
    window.addEventListener("load", schedule);

    var t;
    window.addEventListener("resize", function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    });

    // The theme re-renders the gallery on variant change, and opening an accordion in
    // the info column changes its height, which moves the sticky release point.
    var outer = document.querySelector(".product__outer") || document.querySelector(SEL.wrap);
    if (outer && window.MutationObserver) {
      new MutationObserver(schedule).observe(outer, { childList: true, subtree: true });
    }
    document.addEventListener("toggle", schedule, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();